var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullpush(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.972656,
    y: 0.800781,
    width: 43.4019,
    height: 43.4019,
    rx: 6,
    fill: "#ECF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5505 14.601L15.0661 22.9572C14.5005 23.2822 14.5723 24.0697 15.1348 24.3072L18.4567 25.701L27.4349 17.7885C27.6067 17.6353 27.8505 17.8697 27.7036 18.0478L20.1755 27.2197V29.7353C20.1755 30.4728 21.0661 30.7635 21.5036 30.2291L23.488 27.8135L27.3817 29.4447C27.8255 29.6322 28.3317 29.3541 28.413 28.876L30.663 15.376C30.7692 14.7447 30.0911 14.2885 29.5505 14.601Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullpush);
export default __webpack_public_path__ + "static/media/fullpush.d89afbd974608c36035362e218d368c9.svg";
export { ForwardRef as ReactComponent };